import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

import { CartState } from '../../application/states/cart.state';
import { Product } from '../../models/product';
import { QuantityControlComponent } from '../quantity-control/quantity-control.component';

/**
 * The control of a product that has options: always "Add", which opens the options through `add`, or
 * "Sold out". It has no −/+ of its own — what is in the cart is counted on the rows under it
 * (`plys-configured-items`), one per variant or deal, each with its own −/+.
 */
@Component({
  selector: 'plys-options-quantity',
  template: `
    <plys-quantity-control
      [size]="size"
      [value]="0"
      [disabled]="disabled || (reserving$ | async)"
      [addLabel]="'product_options.add' | transloco"
      [addTestId]="'options-' + product.name"
      [soldOutLabel]="product.soldOut ? ('product_options.sold_out' | transloco) : null"
      (increased)="add.emit()"
    ></plys-quantity-control>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, TranslocoModule, QuantityControlComponent],
})
export class OptionsQuantityComponent {
  @Input() product: Product;
  @Input() disabled = false;
  @Input() size = 'md';
  @Output() add = new EventEmitter<void>();

  readonly reserving$ = this.cartState.reserving$;

  constructor(private readonly cartState: CartState) {}
}
